import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import useFeatureFlag from 'src/shared/hooks/useFeatureFlag';
import { FeatureFlagId } from 'src/shared/types/cms/feature';
import NestedSidebarMenuItem from './NestedSidebarMenuItem';
import { getSiteNatureRiskSiteId } from './siteNatureRiskHelper';

const SiteNatureRiskMenu = () => {
    const navigate = useAppNavigation();
    const { pathname } = useLocation();
    // Characteristics is a sub-flag under Risk Insights — both must be enabled.
    const { enabled: riskInsightsEnabled } = useFeatureFlag({ featureId: FeatureFlagId.RISK_INSIGHTS });
    const { enabled: characteristicsFlagEnabled } = useFeatureFlag({ featureId: FeatureFlagId.NATURE_RISK_SITE_CHARACTERISTICS });
    const characteristicsEnabled = riskInsightsEnabled && characteristicsFlagEnabled;

    const siteId = getSiteNatureRiskSiteId(pathname);

    if (!siteId) {
        return null;
    }

    const isSiteNatureRiskActive = pathname.startsWith('/site-nature-risk/');
    const subItems = [
        {
            title: 'Overview',
            testId: 'site-nature-risk-overview-menu-item',
            onClick: () => navigate.toSiteNatureRiskOverview(siteId),
            isActive: pathname.includes('/overview'),
        },
        ...(characteristicsEnabled
            ? [
                  {
                      title: 'Characteristics',
                      testId: 'site-nature-risk-characteristics-menu-item',
                      onClick: () => navigate.toSiteNatureRiskCharacteristics(siteId),
                      isActive: pathname.includes('/characteristics'),
                  },
              ]
            : []),
        {
            title: 'State of Nature',
            testId: 'site-nature-risk-state-of-nature-menu-item',
            onClick: () => navigate.toSiteNatureRiskStateOfNature(siteId),
            isActive: pathname.includes('/state-of-nature'),
        },
        {
            title: 'Impacts & Dependencies',
            testId: 'site-nature-risk-impacts-and-dependencies-menu-item',
            onClick: () => navigate.toSiteNatureRiskImpactsAndDependencies(siteId),
            isActive: pathname.includes('/impacts-and-dependencies'),
        },
    ];

    return (
        <NestedSidebarMenuItem
            label='Nature Risk'
            testId='site-nature-risk-menu-button'
            icon={<ShieldAlert />}
            isActive={isSiteNatureRiskActive}
            defaultOpen={isSiteNatureRiskActive}
            subItems={subItems}
        />
    );
};

export default SiteNatureRiskMenu;
